"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.avatar.list': '头像',
    'route.avatar.create': '添加头像',
    'route.avatar.edit': '编辑头像',
    'route.avatar.preview': '头像预览',
};
